var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: "流水投诉",
            width: "500px",
            visible: _vm.dialogVisible,
            "append-to-body": true
          },
          on: { close: _vm.close }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "add-goods-form",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "content" } },
                [
                  _c("el-input", {
                    ref: "content",
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入投诉原因",
                      rows: 4
                    },
                    model: {
                      value: _vm.ruleForm.content,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "content", $$v)
                      },
                      expression: "ruleForm.content"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnLoading },
                  on: { click: _vm.submit }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6ac62210", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6ac62210","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/flowingWater/components/flowingWaterTable/components/detailDialog/components/complaintDialog/index.vue
// module id = null
// module chunks = 